import React, { useRef, useState, forwardRef, useImperativeHandle } from 'react';
import "./composer.scss";
import Utils from "utils";
import { VoiceRecorder, ProgressLoader, Popup, Input, EmojiPicker, CustomButton } from 'components/shared';
import $ from "jquery";

export const MessageComposer = forwardRef((props, ref) => {

    const [message, setMessage] = useState(``);
    const hiddenImageChoser = useRef();
    const hiddenFileChoser = useRef();
    const emojiPickerRef = useRef();
    const [withAttachement, setWithAttachement] = useState(false);
    const [urlAttachement, setUrlAttachement] = useState(null);
    const [base64Attachement, setBase64Attachement] = useState({ conversion: null, extension: null });
    const emojiToggleId = "emoji-shower";
    const [attachment, setAttachment] = useState();
    const [displayAudioRec, setDisplayAudioRec] = useState(false);
    const [messageInProgress, setMessageInProgress] = useState(false);

    //SENDING MESSAGE
    const handleSubmitMessage = (e) => {
        e.preventDefault();
        //ATTACHMENT CASE
        (withAttachement && base64Attachement.conversion && base64Attachement.extension)
            && props.sendAttachement(base64Attachement, message);

        //TEXT CASE
        (message) && props.sendEvent(message);
        cleanComposerForm();
        setMessageInProgress(true);
    }

    //ON COMPOSER RESET 
    const cleanComposerForm = () => {
        setWithAttachement(false);
        setMessage(``);
    }

    //ON IMAGE UPLOAD
    const onImageUploadEvent = (e) => {
        Utils.fileToBase64(e.target.files[0]).then((result) => {
            setAttachment(e.target.files[0]);
            setUrlAttachement(URL.createObjectURL(e.target.files[0]));
            setWithAttachement(true);
            setBase64Attachement({ conversion: result, extension: e.target.files[0].name.split('.').pop() });
        }, error => {
            setWithAttachement(false);
            alert(error);
        })
    }

    //ON CANCEL UPLOAD
    const onCancelUpload = () => {
        setAttachment(null);
        setUrlAttachement(null);
        setWithAttachement(false);
        hiddenFileChoser.current.value = null;
        hiddenImageChoser.current.value = null;
    }

    //ON FILE UPLOAD
    const onAttachmentUploadEvent = (e, audio = null) => {
        if (e) {
            Utils.fileToBase64(e.target.files[0]).then((result) => {
                setAttachment(e.target.files[0]);
                setUrlAttachement(URL.createObjectURL(e.target.files[0]));
                setWithAttachement(true);
                setBase64Attachement({ conversion: result, extension: e.target.files[0].name.split('.').pop() });
            }, error => {
                setWithAttachement(false);
                alert(error);
            });
        } else if (audio) {
            Utils.fileToBase64(audio).then((result) => {
                setAttachment(audio);
                setUrlAttachement(URL.createObjectURL(audio));
                setWithAttachement(true);
                setBase64Attachement({ conversion: result, extension: "mp3" });
            }, error => {
                setWithAttachement(false);
                alert(error);
            });
        }
    }

    useImperativeHandle(ref,
        () => ({
            manageMessageProgressStatus(status) {
                setMessageInProgress(status);
            }
        })
    )

    /**
     * On composer message update
     * @param {String} val target message value
     */
    const onMessageChange = (val) => {
        setMessage(val);
        $('.compose-input').css('direction', `${Utils.isArabicFirstChar(val) ? 'rtl' : 'ltr'}`);
    }

    return (
        <>
            {
                props.displayed &&
                <div className="composer-content text-center pb-2">
                    <>
                        <form onSubmit={handleSubmitMessage}>
                            <div className="compose-message">
                                <Input
                                    type="text"
                                    className="compose-input form-control"
                                    placeholder=" Type a message"
                                    value={message}
                                    onChange={(e) => { onMessageChange(e.target.value); }}
                                />
                                &nbsp;
                                {(message || withAttachement) && <CustomButton icon="bi bi-cursor" rounded type="submit" />}
                                {messageInProgress && <div className="mx-3"><ProgressLoader md color="#ED1C24" /></div>}
                            </div>
                            {
                                withAttachement &&
                                <ThumbAttachment
                                    attachment={{
                                        type: attachment.type.split("/")[0],
                                        url: urlAttachement,
                                        name: attachment.name
                                    }}
                                    cancel={onCancelUpload} />
                            }
                        </form>

                        <div className="compose-actions d-flex justify-content-between">
                            <div className="left-actions">
                                {/* TODO LEFT ACTIONS */}
                            </div>

                            <div className="right-actions">
                                <CustomButton icon="bi bi-mic-fill" rounded tooltip="Voice clips" className="p-button-outlined" onClick={() => { setDisplayAudioRec(!displayAudioRec) }} />
                                &nbsp;
                                <CustomButton icon="pi pi-paperclip" rounded tooltip="Attachement" className="p-button-outlined" onClick={() => { hiddenFileChoser?.current.click(); }} />
                                <input type="file" hidden ref={hiddenFileChoser} onChange={(e) => onAttachmentUploadEvent(e)} />
                                &nbsp;
                                <CustomButton icon="bi bi-images" rounded className="p-button-outlined" tooltip="Image" onClick={() => { hiddenImageChoser?.current.click(); }} />
                                <input type="file" hidden ref={hiddenImageChoser} accept="image/*" onChange={(e) => onImageUploadEvent(e)} />
                                &nbsp;
                                <CustomButton id={emojiToggleId} icon="bi bi-emoji-smile" rounded tooltip="Emojis" className="p-button-outlined" onClick={() => emojiPickerRef?.current.showEmojiPicker()} />
                            </div>
                        </div>

                        <div style={{ position: "relative" }}>
                            <EmojiPicker ref={emojiPickerRef} showerId={emojiToggleId} callbackfn={(emoji) => setMessage(`${message}${emoji}`)} />
                        </div>

                        <Popup header="Voice recording"
                            visible={displayAudioRec}
                            onHide={() => setDisplayAudioRec(false)}
                            dismissableMask
                            sticked
                            style={{ width: "30vw" }}
                            position="bottom-left">
                            <VoiceRecorder callbackFileUpload={
                                (file) => {
                                    setDisplayAudioRec(false);
                                    onAttachmentUploadEvent(null, file);
                                }} />
                        </Popup>
                    </>
                </div>
            }
        </>

    );
});

const ThumbAttachment = (props) => {

    function renderAttachment() {
        const { attachment } = props;
        switch (attachment.type) {
            case ("image"): {
                return (
                    <img src={attachment.url} height={50} alt="img" />
                );
            }
            default: {
                return (
                    <div>
                        <i className="pi pi-paperclip" /> {attachment.name}</div>
                );
            }
        }
    }

    return (
        <div className="justify-content-between d-flex px-3">
            <div style={{ position: "relative", width: "fit-content" }}>
                <span style={{ position: "absolute", top: -10, right: -10, cursor: "pointer" }} onClick={props.cancel} ><i className="bi bi-x-circle-fill" /></span>
                {
                    renderAttachment()
                }
            </div>
        </div>
    );
}